<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>

export default {
  name: "app",
  components: {},
  metaInfo: {
    title: "Hệ thống hỗ trợ nâng cao chất lượng tài liệu",
    titleTemplate: "%s | Hệ thống hỗ trợ nâng cao chất lượng tài liệu",
    meta: [
      {
        property: "og:title",
        content: "Hệ thống hỗ trợ nâng cao chất lượng tài liệu",
      },
      {
        name: "description",
        content: "Hệ thống kiểm tra trùng lặp và sửa lỗi chính tả",
      },
      {
        name: "keywords",
        content: "DoIT, doit, uet, đạo văn, kiểm tra chính tả, trùng lặp luận văn",
      },
      {
        property: "fb:pages",
        content: "1186262898051617",
      },
      {
        property: "fb:admins",
        content: "1186262898051617",
      },
      {
        property: "og:url",
        content: window.location.href,
      },
      {
        property: "al:web:url",
        content: window.location.href,
      },
      {
        property: "og:locale",
        content: "vi_VN",
      },
      {
        name: "robots",
        content: "index,follow,all",
      },
      {
        name: "Googlebot",
        content: "index,follow,archive",
      },
    ],
    link: [
      { rel: "canonical", href: window.location.href },
      { rel: "publisher", href: "https://facebook.com/doitvn" },
      { rel: "author", href: "https://facebook.com/doitvn" },
      {
        rel: "stylesheet",
        href: "https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.2/css/all.min.css",
        integrity: "sha512-HK5fgLBL+xu6dm/Ii3z4xhlSUyZgTT9tuc/hSrtw6uzJOvgRr2a9jyxxT1ely+B+xFAmJKVSTbpM/CuL7qxO8w==",
        crossorigin: "anonymous",
      },
      {
        rel: "stylesheet",
        href: "https://stackpath.bootstrapcdn.com/bootstrap/4.3.1/css/bootstrap.min.css",
        integrity: "sha384-ggOyR0iXCbMQv3Xipma34MD+dH/1fQ784/j6cY/iJTQUOhcWr7x9JvoRxT2MZw1T",
        crossorigin: "anonymous",
      },
    ],
  },
}
</script>

<style>
* {
  font-family: "Open Sans", sans-serif;
  font-size: 14px;
}
</style>
